import React from 'react';
import { CheckIcon, XIcon, ShieldCheckIcon } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { FAQAccordion } from '../components/FAQAccordion';
import { SocialProofPopup } from '../components/SocialProofPopup';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/cKTQs8quNHmeRzXoLeRRUy/Mockup_-_Sistema_Integral_Abdomen_Liviano_2B40.png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/ni3zF9eHTNynTtKLD796gF/Mockup_-_Bono_1.png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/sJ2dLn2Ep6Eefm4LcZrb2C/Mockup_-_Bono_2.png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/um9JXCFNVaq3UkBEXwb5LX/Mockup_-_Bono_3.png';
const CHECKOUT_LINK = 'https://checkout.tumundoglobal.online/cart/45217286717631:1';
const SECTION_LINK = '#compra';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-20" data-id="element-34">
      <CountdownTimer data-id="element-35" />
      <SocialProofPopup data-id="element-36" />

      {/* HERO SECTION */}
      <section className="pt-8 pb-12 px-4 md:pt-12 md:pb-20 bg-gradient-to-b from-white to-gray-50" data-id="element-37">
        <div className="max-w-4xl mx-auto text-center" data-id="element-38">
          <div className="inline-flex items-center justify-center bg-green-100 text-green-700 px-6 py-2 rounded-full mb-6" data-id="element-39">
            <span className="text-sm md:text-base font-medium uppercase tracking-wide" data-id="element-40">
              🌿 PARA MUJERES 40+ QUE QUIEREN VOLVER A SENTIR SU ABDOMEN LIVIANO
              SIN DIETAS EXTREMAS
            </span>
          </div>

          <h1 className="text-[28px] md:text-5xl font-black tracking-tight text-gray-900 mb-8 leading-[1.15]" data-id="element-41">
            Reducí tu inflamación abdominal en 21 días sin dietas extremas,
            incluso si tu cuerpo ya cambió después de los 40.
          </h1>

          <div className="mb-6" data-id="element-42">
            <a href={SECTION_LINK} data-id="element-43">
              <img src={PRODUCT_IMAGE} alt="Sistema Integral Abdomen Liviano 40+" className="w-full max-w-lg mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-44" />
            </a>
          </div>

          <p className="text-xl md:text-2xl font-bold text-gray-900 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-45">
            Un sistema estructurado y vegetal diseñado para mujeres
            profesionales en transición hormonal que buscan{' '}
            <span className="bg-yellow-300 px-1" data-id="element-46">estabilidad digestiva</span>,{' '}
            <span className="bg-yellow-300 px-1" data-id="element-47">energía constante</span> y{' '}
            <span className="bg-yellow-300 px-1" data-id="element-48">control metabólico real</span>.
          </p>

          <CTAButton data-id="element-49">👉 SÍ, QUIERO DESINFLAMAR MI ABDOMEN</CTAButton>
        </div>
      </section>

      {/* PROBLEM SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-50">
        <div className="max-w-3xl mx-auto" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-52">
            Si estás haciendo "lo mismo de siempre", dejame preguntarte algo
            honesto…
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-53">
            <p className="font-medium" data-id="element-54">
              ¿Te despertás con el abdomen plano… pero a las 5 pm estás
              inflamada?
            </p>
            <p data-id="element-55">¿Sentís que tu digestión es más lenta que antes?</p>
            <p data-id="element-56">¿Aparecieron antojos que no tenías?</p>
            <p data-id="element-57">¿Tu energía sube y baja sin explicación?</p>
            <p data-id="element-58">¿Lo que antes funcionaba… ahora ya no funciona?</p>

            <p className="text-xl font-bold text-gray-900 mt-8" data-id="element-59">
              No es falta de disciplina. No es que estés haciendo algo mal.
            </p>
            <p data-id="element-60">
              Tu cuerpo está entrando en una transición hormonal real. Y
              necesita una estrategia diferente.
            </p>
            <p className="text-center font-bold text-2xl mt-8 border-l-4 border-[#dc2626] pl-4 py-2 bg-red-50" data-id="element-61">
              Y necesita una estrategia diferente.
            </p>
          </div>

          <div className="mt-12" data-id="element-62">
            <CTAButton data-id="element-63">QUIERO DEJAR DE SENTIRME ASÍ</CTAButton>
          </div>
        </div>
      </section>

      {/* PAIN POINTS SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-64">
        <div className="max-w-4xl mx-auto" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-yellow-400" data-id="element-66">
            El problema que casi nadie explica
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-67">
            <div className="space-y-4" data-id="element-68">
              <p className="text-xl font-medium mb-6" data-id="element-69">
                Entre los 38 y 48 años empiezan cambios silenciosos:
              </p>
              <ul className="space-y-4" data-id="element-70">
                {['El estrógeno fluctúa', 'La progesterona cambia', 'La insulina se vuelve más sensible', 'El cortisol responde más al estrés'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-71">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-72" />
                    <span className="text-lg" data-id="element-73">{item}</span>
                  </li>)}
              </ul>
              <p className="text-lg font-medium mt-6 text-gray-300" data-id="element-74">
                Y eso genera:
              </p>
              <ul className="space-y-2 mt-2" data-id="element-75">
                {['Inflamación abdominal diaria', 'Retención leve', 'Sensibilidad digestiva', 'Grasa nueva en abdomen bajo', 'Antojos más frecuentes', 'Energía inestable'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-76">
                    <span className="flex-shrink-0" data-id="element-77">🔴</span>
                    <span className="text-[#FFFFFF]" data-id="element-78">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-gray-800 p-8 rounded-xl border border-gray-700" data-id="element-79">
              <p className="text-lg mb-6" data-id="element-80">
                Lo peor es esa sensación interna de:
              </p>
              <p className="text-2xl font-bold italic text-gray-300 mb-8" data-id="element-81">
                "Estoy haciendo todo lo posible… pero mi cuerpo no responde."
              </p>

              <div className="space-y-2 font-bold text-red-400 text-xl" data-id="element-82">
                <p data-id="element-83">❌ La solución no es hacer keto extremo.</p>
                <p data-id="element-84">❌ La solución no es dejar de comer.</p>
                <p data-id="element-85">❌ La solución no es castigarte.</p>
              </div>

              <p className="mt-6 text-gray-300" data-id="element-86">
                La solución es{' '}
                <span className="text-white font-bold" data-id="element-87">
                  estructura metabólica inteligente
                </span>
                .
              </p>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-88">
            <p className="text-2xl font-bold text-[#22c55e]" data-id="element-89">
              👉 Sistema Integral Abdomen Liviano 40+™ nace para cortar ese
              ciclo.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-90">
        <div className="max-w-5xl mx-auto" data-id="element-91">
          <div className="text-center mb-16" data-id="element-92">
            <span className="bg-green-100 text-green-800 px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wide" data-id="element-93">
              ✅ LA SOLUCIÓN
            </span>
            <h2 className="text-4xl md:text-5xl font-black mt-6 mb-8" data-id="element-94">
              Sistema Integral Abdomen Liviano 40+™
            </h2>
            <div className="bg-green-50 p-8 rounded-2xl border border-green-100 max-w-3xl mx-auto mb-16" data-id="element-95">
              <p className="text-lg font-semibold text-green-800 mb-4" data-id="element-96">
                Un sistema completo, progresivo y ejecutable diseñado para:
              </p>
              <ul className="space-y-3" data-id="element-97">
                {['Desinflamar tu abdomen', 'Estabilizar tu digestión', 'Regular picos de glucosa', 'Reducir antojos', 'Automatizar tu alimentación', 'Mantener resultados sin recaídas'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-98">
                    <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-99" />
                    <span className="text-gray-700 text-lg font-bold" data-id="element-100">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-101">
            <div className="bg-green-50 p-8 rounded-2xl border border-green-100" data-id="element-102">
              <h3 className="text-2xl font-bold mb-6" data-id="element-103">
                No es un ebook. No es un simple recetario.
              </h3>
              <p className="text-gray-700 mb-6 font-medium" data-id="element-104">
                Es un sistema estructurado.
              </p>
              <ul className="space-y-4" data-id="element-105">
                {['Sin dietas extremas', 'Sin improvisación', 'Sin eliminar grupos de alimentos', 'Solo estructura metabólica real'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-106">
                    <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-107" />
                    <span className="text-lg font-medium text-gray-800" data-id="element-108">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col justify-center items-center text-center p-8 bg-gray-50 rounded-2xl border border-gray-100" data-id="element-109">
              <div className="space-y-6 text-xl font-bold text-gray-800" data-id="element-110">
                <div className="flex items-center gap-4" data-id="element-111">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0" data-id="element-112">
                    1
                  </span>
                  <span className="text-left" data-id="element-113">
                    📂 Abrís el tomo correspondiente
                  </span>
                </div>
                <div className="flex items-center gap-4" data-id="element-114">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0" data-id="element-115">
                    2
                  </span>
                  <span className="text-left" data-id="element-116">
                    📋 Aplicás el protocolo paso a paso
                  </span>
                </div>
                <div className="flex items-center gap-4" data-id="element-117">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0" data-id="element-118">
                    3
                  </span>
                  <span className="text-left" data-id="element-119">
                    📊 Medís resultados y ajustás
                  </span>
                </div>
              </div>
              <p className="mt-8 text-lg text-gray-600 italic" data-id="element-120">
                Sin improvisación. Sin dietas extremas. Sin empezar de cero cada
                lunes.
              </p>
            </div>
          </div>

          <CTAButton data-id="element-121">👉 QUIERO EMPEZAR AHORA</CTAButton>
        </div>
      </section>

      {/* MODULES SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-122">
        <div className="max-w-5xl mx-auto" data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-124">
            📘 La progresión de resultados que lograrás en cada fase
          </h2>
          <p className="text-center text-xl text-gray-600 mb-12" data-id="element-125">
            🔹 5 TOMOS PRINCIPALES: Un entrenamiento progresivo de regulación
            metabólica
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-126">
            {[{
            title: 'Tomo 1 – Reset Anti-Inflamatorio (7 días)',
            results: ['Abdomen visiblemente menos inflamado', 'Sensación de ligereza', 'Menos retención', 'Menos pesadez post comida']
          }, {
            title: 'Tomo 2 – Intestino Liviano (10 días)',
            results: ['Disminución de gases', 'Menos distensión', 'Tránsito más regular', 'Abdomen plano por más horas']
          }, {
            title: 'Tomo 3 – Hormonas e Insulina (14 días)',
            results: ['Menos grasa abdominal baja', 'Menos antojos dulces', 'Hambre más estable', 'Energía constante']
          }].map((tomo, i) => <a key={i} href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-127">
                <div className="text-4xl mb-4" data-id="element-128">📘</div>
                <h3 className="text-xl font-bold mb-3" data-id="element-129">{tomo.title}</h3>
                <ul className="space-y-2" data-id="element-130">
                  {tomo.results.map((r, j) => <li key={j} className="flex items-center gap-2 text-gray-600 text-sm" data-id="element-131">
                      <CheckIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-132" />
                      <span data-id="element-133">{r}</span>
                    </li>)}
                </ul>
              </a>)}
          </div>

          <div className="grid md:grid-cols-2 gap-6 mt-6 md:max-w-[calc(66.666%+12px)] lg:max-w-[calc(66.666%+12px)] mx-auto" data-id="element-134">
            {[{
            title: 'Tomo 4 – Sistema Automático Anti-Inflamatorio',
            results: ['Alimentación organizada', 'Menos decisiones diarias', 'Mayor consistencia', 'Menos recaídas']
          }, {
            title: 'Tomo 5 – Mantenimiento 40+',
            results: ['Estabilidad a largo plazo', 'Seguridad en eventos sociales', 'Adaptación a tu etapa hormonal', 'Confianza sostenida']
          }].map((tomo, i) => <a key={i} href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-135">
                <div className="text-4xl mb-4" data-id="element-136">📘</div>
                <h3 className="text-xl font-bold mb-3" data-id="element-137">{tomo.title}</h3>
                <ul className="space-y-2" data-id="element-138">
                  {tomo.results.map((r, j) => <li key={j} className="flex items-center gap-2 text-gray-600 text-sm" data-id="element-139">
                      <CheckIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-140" />
                      <span data-id="element-141">{r}</span>
                    </li>)}
                </ul>
              </a>)}
          </div>

          <p className="text-center text-lg font-medium mt-12 text-gray-700" data-id="element-142">
            👉 Todo organizado para que sepas qué hacer y cuándo hacerlo.
          </p>
        </div>
      </section>

      {/* BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-143">
        <div className="max-w-4xl mx-auto" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-145">
            Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-146">
            <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-147">
              <h3 className="text-xl font-bold text-red-800 mb-6 text-center" data-id="element-148">
                Antes de Abdomen Liviano 40+
              </h3>
              <ul className="space-y-4" data-id="element-149">
                {['Inflamación diaria', 'Abdomen plano solo por la mañana', 'Antojos constantes', 'Energía inestable', 'Sensación de descontrol'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-150">
                    <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-151" />
                    <span className="text-gray-700" data-id="element-152">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-green-50 p-8 rounded-2xl border border-green-100 shadow-lg transform md:-translate-y-4" data-id="element-153">
              <h3 className="text-xl font-bold text-green-800 mb-6 text-center" data-id="element-154">
                Después de Abdomen Liviano 40+
              </h3>
              <ul className="space-y-4" data-id="element-155">
                {['Abdomen liviano durante el día', 'Digestión estable', 'Menos antojos', 'Energía constante', 'Sensación real de control'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-156">
                    <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-157" />
                    <span className="font-bold text-gray-800" data-id="element-158">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-16 px-4 bg-[#0f172a] text-white" data-id="element-159">
        <div className="max-w-5xl mx-auto" data-id="element-160">
          <div className="text-center mb-12" data-id="element-161">
            <span className="bg-yellow-400 text-black px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wide animate-pulse" data-id="element-162">
              🎁 BONOS ESPECIALES INCLUIDOS HOY
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mt-6 mb-4" data-id="element-163">
              BONOS INCLUIDOS HOY
            </h2>
            <p className="text-xl text-yellow-400 font-bold" data-id="element-164">
              ¡GRATIS POR HOY!
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-165">
            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-166">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-167">
                <img src={BONUS_1_IMAGE} alt="Bono 1 - Protocolo Express 72 Horas" className="w-full h-full object-contain drop-shadow-xl" data-id="element-168" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-169">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-170">
                🎁 Bono #1 – Protocolo Express 72 Horas
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-171">
                Un sistema de rescate rápido si te inflamás. Nunca más sentir
                que "perdiste todo".
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-172">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-173">
                <img src={BONUS_2_IMAGE} alt="Bono 2 - Guía Clínica Simplificada" className="w-full h-full object-contain drop-shadow-xl" data-id="element-174" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-175">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-176">
                🎁 Bono #2 – Guía Clínica Simplificada
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-177">
                Entendé qué pasa con tu estrógeno, progesterona, insulina,
                cortisol y microbiota. Explicado claro y aplicable.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-178">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-179">
                <img src={BONUS_3_IMAGE} alt="Bono 3 - Plan Energía y Productividad 40+" className="w-full h-full object-contain drop-shadow-xl" data-id="element-180" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-181">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-182">
                🎁 Bono #3 – Plan Energía y Productividad 40+
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-183">
                Sin bajón de las 4 pm. Sin antojos de oficina. Sin niebla
                mental. Más rendimiento profesional.
              </p>
            </a>
          </div>

          <div className="mt-12 text-center space-y-2 text-lg font-medium" data-id="element-184">
            <p data-id="element-185">👉 Los tomos te estructuran.</p>
            <p data-id="element-186">👉 Los bonos te sostienen.</p>
            <p className="text-yellow-400 font-bold text-xl mt-4" data-id="element-187">
              Eso es lo que lo vuelve diferente.
            </p>
          </div>

          <div className="mt-12" data-id="element-188">
            <CTAButton data-id="element-189">QUIERO MIS BONOS AHORA</CTAButton>
          </div>
        </div>
      </section>

      {/* OFFER STACK SECTION */}
      <section id="compra" className="py-16 px-4 bg-gradient-to-b from-gray-900 to-gray-800" data-id="element-190">
        <div className="max-w-4xl mx-auto" data-id="element-191">
          <div className="text-center mb-10" data-id="element-192">
            <span className="bg-red-500 text-white px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wide animate-pulse inline-block mb-4" data-id="element-193">
              ⏰ OFERTA ESPECIAL POR TIEMPO LIMITADO
            </span>
            <h2 className="text-4xl md:text-6xl font-black text-white uppercase leading-tight" data-id="element-194">
              Oferta por
              <br data-id="element-195" />
              <span className="text-yellow-400" data-id="element-196">Tiempo Limitado</span>
            </h2>
          </div>

          <div className="bg-white rounded-3xl p-6 md:p-12 shadow-2xl" data-id="element-197">
            <h3 className="text-2xl md:text-3xl font-black text-center mb-8 text-gray-900" data-id="element-198">
              📦 Hoy recibís:
            </h3>

            <div className="space-y-4 mb-10" data-id="element-199">
              {['5 Tomos completos', 'Bono "Protocolo Express 72 Horas"', 'Bono "Guía Clínica Simplificada"', 'Bono "Plan Energía y Productividad 40+"', 'Acceso digital inmediato', 'Acceso de por vida'].map((item, i) => <div key={i} className="flex items-center gap-3 text-lg md:text-xl border-b border-gray-200 pb-3 last:border-0" data-id="element-200">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-201" />
                  <span className="font-bold text-gray-800" data-id="element-202">{item}</span>
                </div>)}
            </div>

            <div className="text-center mb-8" data-id="element-203">
              <p className="text-gray-500 text-xl mb-2" data-id="element-204">
                Valor real de mercado:{' '}
                <span className="line-through decoration-red-500 decoration-2" data-id="element-205">
                  $49.990 ARS
                </span>
              </p>
              <p className="text-5xl md:text-7xl font-black text-[#22c55e]" data-id="element-206">
                🔥 $19.990 ARS
              </p>
              <p className="text-gray-600 mt-2 font-medium" data-id="element-207">Solo por hoy</p>
            </div>

            <div className="flex flex-col items-center justify-center w-full" data-id="element-208">
              <a href={CHECKOUT_LINK} className="relative group flex items-center justify-center gap-2 w-full md:max-w-2xl px-6 py-5 md:py-6 bg-[#22c55e] hover:bg-[#16a34a] text-white text-center rounded-xl shadow-xl hover:shadow-2xl transform transition-all duration-200 hover:-translate-y-1 border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1 text-xl md:text-2xl font-bold uppercase tracking-wide" data-id="element-209">
                👉 OBTENER MI SISTEMA AHORA
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 md:w-7 md:h-7" data-id="element-210">
                  <path d="M5 12h14" data-id="element-211" />
                  <path d="m12 5 7 7-7 7" data-id="element-212" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE SECTION */}
      <section className="py-12 px-4 bg-gray-800" data-id="element-213">
        <div className="max-w-4xl mx-auto" data-id="element-214">
          <div className="flex flex-col md:flex-row items-center gap-6 bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20" data-id="element-215">
            <ShieldCheckIcon className="w-20 h-20 text-yellow-400 flex-shrink-0" data-id="element-216" />
            <div className="text-center md:text-left text-white" data-id="element-217">
              <h3 className="text-2xl font-bold mb-3" data-id="element-218">Garantía de 7 Días</h3>
              <p className="text-gray-300 text-lg leading-relaxed" data-id="element-219">
                Probalo durante 7 días. Si sentís que no es para vos, solicitás
                reembolso y recuperás el 100% de tu dinero.
                <br data-id="element-220" />
                <span className="font-bold text-white" data-id="element-221">
                  Sin interrogatorios. Sin explicaciones incómodas.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PREVIEW PAGES SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-222">
        <div className="max-w-4xl mx-auto" data-id="element-223">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-224">
            📖 Revisá algunas hojas
          </h2>
          <p className="text-center text-gray-600 mb-10" data-id="element-225">
            Mirá una muestra del contenido real que vas a recibir:
          </p>

          {/* Preview placeholder - images will be added here */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 min-h-[300px]" data-id="element-226">
            {/* Placeholder slots for preview images */}
            {[1, 2, 3].map(slot => <div key={slot} className="aspect-[3/4] bg-gray-100 rounded-xl flex items-center justify-center border-2 border-dashed border-gray-300" data-id="element-227">
                <p className="text-gray-400 text-sm text-center px-4" data-id="element-228">
                  Página de muestra {slot}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-229">
        <div className="max-w-6xl mx-auto" data-id="element-230">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-231">
            Lo que dicen quienes ya lo probaron
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-232">
            <TestimonialCard name="Patricia" age={44} location="Buenos Aires" quote="Llevaba años con esa inflamación de las 5 pm que no entendía. Con el Tomo 1 en 7 días ya noté la diferencia. Por fin entendí que era hormonal, no falta de voluntad." data-id="element-233" />
            <TestimonialCard name="Claudia" age={47} location="Córdoba" quote="Estoy en perimenopausia y nada de lo que hacía antes funcionaba. Este sistema me dio estructura real. Mi digestión mejoró y los antojos bajaron muchísimo." data-id="element-234" />
            <TestimonialCard name="Mónica" age={42} location="Rosario" quote="La grasa en el abdomen bajo que apareció después de los 40 me desesperaba. El Tomo 3 me explicó exactamente por qué pasa y cómo manejarlo. Increíble." data-id="element-235" />
          </div>
          <div className="grid md:grid-cols-3 gap-6 mt-6" data-id="element-236">
            <TestimonialCard name="Graciela" age={49} location="Mendoza" quote="Soy profesional, tengo poco tiempo y necesitaba algo ejecutable. Este sistema es exactamente eso. Sin vueltas, sin improvisación. El bono de energía me salvó la tarde." data-id="element-237" />
            <TestimonialCard name="Silvia" age={45} location="La Plata" quote="Mi digestión era un desastre desde que entré en la perimenopausia. Con el Tomo 2 en 10 días el cambio fue notable. Menos gases, menos distensión, más energía." data-id="element-238" />
            <TestimonialCard name="Andrea" age={43} location="Santa Fe" quote="Pensé que era normal sentirme así a los 40. La Guía Clínica me abrió los ojos. Entendí mis hormonas y ahora tengo herramientas reales para manejar mi cuerpo." data-id="element-239" />
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-240">
        <div className="max-w-3xl mx-auto" data-id="element-241">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-242">
            Preguntas Frecuentes
          </h2>
          <FAQAccordion data-id="element-243" />
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 px-4 bg-gray-900 text-white text-center" data-id="element-244">
        <div className="max-w-3xl mx-auto" data-id="element-245">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-246">
            🌿 Tu cuerpo cambió.
          </h2>
          <p className="text-xl text-gray-300 mb-6 leading-relaxed" data-id="element-247">
            Tu estrategia también debe cambiar.
          </p>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-248">
            No estás perdiendo juventud. Estás entrando en una etapa que
            necesita{' '}
            <span className="text-white font-bold" data-id="element-249">
              inteligencia metabólica
            </span>
            .
            <br className="hidden md:block" data-id="element-250" />
            Hoy podés hacerlo con estructura.
          </p>

          <a href={CHECKOUT_LINK} className="inline-flex flex-col items-center justify-center px-12 py-5 md:py-6 bg-[#22c55e] hover:bg-[#16a34a] text-white text-center rounded-xl shadow-xl hover:shadow-2xl transform transition-all duration-200 hover:-translate-y-1 border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1" data-id="element-251">
            <span className="text-lg md:text-xl font-bold uppercase tracking-wide" data-id="element-252">
              HACER CLIC Y COMENZAR AHORA
            </span>
            <span className="text-xl md:text-2xl font-black uppercase tracking-wide" data-id="element-253">
              al Sistema Abdomen Liviano 40+
            </span>
          </a>

          <p className="mt-8 text-yellow-400 font-bold text-lg tracking-wide" data-id="element-254">
            TU CUERPO CAMBIÓ. TU ESTRATEGIA TAMBIÉN DEBE CAMBIAR.
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-8 bg-black text-gray-500 text-center text-sm" data-id="element-255">
        <p data-id="element-256">
          © 2024 Sistema Integral Abdomen Liviano 40+. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-257">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}